import { useState } from "react";
import ProjectItem from "./ProjectItem";
import "../../../styles/Projects.css";

const ProjectListItem = (props) => {
  const [itemOverlayOpen, setItemOverlayOpen] = useState(false);

  const openItemOverlay = () => {
    setItemOverlayOpen(true);
  };

  const closeItemOverlay = () => {
    setItemOverlayOpen(false);
  };

  return (
    <>
      <li
        tabIndex="0"
        onClick={openItemOverlay}
        className={`projects__container--project ${props.class}`}
      >
        <div className="projects__container--project-img">
          <img
            src={props.img}
            alt={`User interface preview for ${props.project}`}
          />
        </div>
        <div className="projects__container--project-overlay">
          <div>
            <h3>{props.project}</h3>
            <a href={props.url} target="_blank" rel="noreferrer">
              Visit Website
            </a>
          </div>
        </div>
      </li>
      {itemOverlayOpen && (
        <ProjectItem
          img={props.img}
          class={props.class}
          description={props.description}
          id={props.id}
          url={props.url}
          tags={props.tags}
          project={props.project}
          itemOpen={itemOverlayOpen}
          closeItem={closeItemOverlay}
        />
      )}
    </>
  );
};

export default ProjectListItem;
